<template>
	<div class="mx-auto mb-4 mt-6 w-full max-w-[328px]">
		<div class="text-xs leading-4.5 text-gray-70">
			{{ $t("foot_note.recommended_retail_price") }}
		</div>
		<div class="text-xs leading-4.5 text-gray-70">
			{{ $t("foot_note.biggest_outlet_explanation") }}
			<a :href="aboutUsLink" class="break-words underline" target="_blank" rel="noopener">{{
				$t("foot_note.more_information")
			}}</a>
		</div>
	</div>
</template>

<script setup lang="ts">
import { $t } from "@/main";

const aboutUsURL = $t("foot_note.about_us_url");
const aboutUsLink = `${window.location.origin}${aboutUsURL}`;
</script>
